import { useLocation } from "react-router-dom";

export const useTypedQueryParams = <
  T extends Record<string, string | number | undefined>
>(): T => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const entries: Record<string, string | undefined> = {};
  searchParams.forEach((value, key) => {
    entries[key] =
      value === "null" || value === "undefined" ? undefined : value;
  });

  return entries as T;
};
